// components/directory-list.js
export class ExpandableDirectory {
  constructor(input = '.directory-list') {
    // Accept selector string OR DOM element
    this.root = typeof input === 'string' 
      ? document.querySelector(input) 
      : input;

    if (!this.root) {
      console.warn('ExpandableDirectory: No root element found for', input);
      return;
    }

    this.init();
  }

  init() {
    const headers = this.root.querySelectorAll('.directory-header');
    headers.forEach(header => {
      header.addEventListener('click', () => this.toggle(header));
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle(header);
        }
      });
    });
  }

  toggle(header) {
    const li = header.parentElement;
    const isOpen = li.classList.contains('open');
    if (isOpen) {
      this.collapse(li);
    } else {
      this.expand(li);
    }
  }

  expand(li) {
    const sub = li.querySelector(':scope > .sub-directory');
    if (!sub) return;

    if (!li.dataset.loaded && li.dataset.path) {
      const path = li.dataset.path;
      fetch(`/get-subdirs?path=${encodeURIComponent(path)}`)
        .then(resp => resp.text())
        .then(html => {
          sub.innerHTML = html;
          li.dataset.loaded = 'true';
          this.expandAfterLoad(li, sub);
        })
        .catch(err => {
          console.error('Failed to load subdirectory:', err);
        });
    } else {
      this.expandAfterLoad(li, sub);
    }
  }

  expandAfterLoad(li, sub) {
    sub.style.display = 'block';
    sub.style.maxHeight = '0px';
    requestAnimationFrame(() => {
      const height = sub.scrollHeight + 'px';
      sub.style.maxHeight = height;
    });
    li.classList.add('open');
    li.setAttribute('aria-expanded', 'true');

    const handler = (e) => {
      if (e.propertyName === 'max-height') {
        sub.style.maxHeight = 'none';
        sub.removeEventListener('transitionend', handler);
      }
    };
    sub.addEventListener('transitionend', handler);
  }

  collapse(li) {
    const sub = li.querySelector(':scope > .sub-directory');
    if (!sub) return;

    const height = sub.scrollHeight + 'px';
    sub.style.maxHeight = height;
    sub.offsetHeight; // force reflow
    requestAnimationFrame(() => {
      sub.style.maxHeight = '0px';
    });

    li.classList.remove('open');
    li.setAttribute('aria-expanded', 'false');

    const handler = (e) => {
      if (e.propertyName === 'max-height') {
        sub.style.display = '';
        sub.removeEventListener('transitionend', handler);
      }
    };
    sub.addEventListener('transitionend', handler);
  }
}